
import { SUBMITAPPROVEEXPENSE_SUCCESS, SUBMITAPPROVEEXPENSE_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const submitApproveReducer = (state = initialState, action) => {
    switch (action.type) {
        case SUBMITAPPROVEEXPENSE_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SUBMITAPPROVEEXPENSE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default submitApproveReducer;
